const conf = {
  clientId: 50012,
  brand: "",
  termsQuantity: 8,
  style: 1,
  tracingTag: "",
  postbackUrl: "",
  categoryFallback: "17",
  d2sLandingPage: "",
  searchTerm: "",
  adTerm: "Search For",
  node: document.currentScript || document.body,
};

export default { ...conf, ...(document.currentScript?.dataset || {}) };
